var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('fineart-head',{attrs:{"activeName":"3"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('login-register-modal',{model:{value:(_vm.isShowed),callback:function ($$v) {_vm.isShowed=$$v},expression:"isShowed"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d244f6b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/mall/mall.vue
// module id = null
// module chunks = 